import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Flex, Row, Space, Switch, Button } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import TableAntd from "components/elements/Table/Table";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import styles from "../styles/EmailLoopList.module.css";

const EmailLoopList = ({
    emailLoopList = [],
    isLoading = false,
    pagination = {},
    onChange = () => { },
    onCreate = () => { },
    onEdit = () => { },
    onDelete = () => { },
    onStatus = () => { },
    onViewMembers = () => { },
    embedded = false,
}) => {
    const { t, i18n } = useTranslation();

    const columns = [
        {
            title: <div className="text-table">{t("common.index")}</div>,
            dataIndex: "id",
            key: "id",
            width: "8%",
            align: "center",
            render: (_, __, index) => index + 1,
        },
        {
            title: <div className="text-table">{t("email_loop.label.group_name")}</div>,
            dataIndex: "groupName",
            key: "groupName",
            width: "18%",
            // render: (v) => <b>{v}</b>,
        },
        {
            title: <div className="text-table">{t("email_loop.label.condition")}</div>,
            dataIndex: "memberConditionList",
            key: "memberConditionList",
            width: "27%",
            render: (list) => {
                const cond = list?.[0] || {};
                const deptNames = cond.departmentList?.map((d) => d.name).join(", ");
                const posNames = cond.positionList?.map((p) => p.name).join(", ");
                return (
                    <>
                        {deptNames && <div>{t("email_loop.label.department")}: {deptNames}</div>}
                        {posNames && <div>{t("email_loop.label.position")}: {posNames}</div>}
                    </>
                );
            },
        },
        {
            title: <div className="text-table">{t("email_loop.label.member_count")}</div>,
            dataIndex: "memberCount",
            key: "memberCount",
            width: "14%",
            align: "center",
        },
        {
            title: <div className="text-table">{t("account_category_list.label.last_modified")}</div>,
            dataIndex: "updateDate",
            key: "updateDate",
            width: "13%",
            render: (_, record) => {
                const { createBy, updateBy, createDate, updateDate } = record;
                const lastModified = updateBy || createBy;
                const name = lastModified
                    ? (i18n.language === "en" && lastModified.nameEn ? lastModified.nameEn : lastModified.name)
                    : null;
                return (
                    <>
                        {name}
                        {name && <br />}
                        {(createDate || updateDate) ? dayjs(updateDate ?? createDate).format("DD/MM/YYYY HH:mm") : "-"}
                    </>
                );
            },
        },
        {
            title: <div className="text-table">{t("year_accumulate_list.label.status")}</div>,
            dataIndex: "isActive",
            key: "isActive",
            align: "center",
            width: "10%",
            render: (v, record) => (
                <Switch checked={v === "Y"} onChange={(checked) => onStatus(checked, record)} />
            ),
        },
        {
            title: <div className="text-table">{t("action.action")}</div>,
            key: "action",
            width: "8%",
            align: "center",
            fixed: "right",
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        menu={{
                            items: [
                                {
                                    key: "view",
                                    onClick: () => onViewMembers(record),
                                    label: t("email_loop.form.view_list"),
                                    icon: <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />,
                                },
                                {
                                    key: "edit",
                                    onClick: () => onEdit(record),
                                    label: t("action.edit"),
                                    icon: <EditOutlined style={{ fontSize: "18px", color: "gray" }} />,
                                },
                                {
                                    key: "delete",
                                    onClick: () => onDelete(record),
                                    label: t("action.delete"),
                                    icon: <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />,
                                },
                            ],
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>
            ),
        },
    ];

    const content = (
        <Space className={styles.container} direction="vertical" size={24}>
            <Row justify="end">
                <Space direction="horizontal" size={24}>
                    <Button
                        onClick={onCreate}
                        style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}
                        type="primary"
                    >
                        <Flex align="center" justify="center" gap={8}>
                            <CreateIcon />
                            <span>{t("email_loop.create")}</span>
                        </Flex>
                    </Button>
                </Space>
            </Row>
            <TableAntd
                columns={columns}
                dataSource={emailLoopList}
                onDelete={onDelete}
                loading={isLoading}
                pagination={pagination}
                onChange={onChange}
                rowKey="id"
            />
        </Space>
    );

    return content;
};

export default EmailLoopList;